// Sponsor name mappings for tooltip display
export const mapSponsors = {
  "Aarhus University Hospital": "Aarhus U.H.",
  "Skane University Hospital": "Skåne U.H.",
  "Copenhagen University Hospital": "Copenhagen U.H.",
  "The National University Hospital of Iceland": "Iceland U.H.",
  "Tampere University Hospital": "Tampere U.H.",
  "Hvidovre and Amager Hospital": "Hvidovre and Amager H.",
  "Karolinska University Hospital": "Karolinska U.H.",
  "Odense University Hospital": "Odense U.H.",
  "Oulu University Hospital": "Oulu U.H.",
  "Herlev and Gentofte Hospital": "Herlev and Gentofte H.",
  "Karolinska Institutet": "Karolinska Institutet",
  "Helsinki University Hospital": "Helsinki U.H.",
  "Haukeland university hospital": "Haukeland U.H.",
  "Zealand University Hospital": "Zealand U.H.",
  "Linkoeping University Hospital": "Linköping U.H.",
  "Uppsala University": "Uppsala U.",
  "Aarhus University": "Aarhus U.",
  "Uppsala Academic Hospital": "Uppsala A.H.",
  "Norwegian University of Science and Technology": "NTNU",
  "Oslo University Hospital": "Oslo U.H.",
  "Aalborg University Hospital": "Aalborg U.H.",
  "University of Tampere": "Tampere U.",
  "Sahlgrenska University Hospital": "Sahlgrenska U.H.",
  "Steno Diabetes Center Copenhagen": "Steno Diabetes Center Copenhagen",
  "University Hospital of Umeå": "Umeå U.H.",
  "Kuopio University Hospital": "Kuopio U.H.",
  "University of Oslo": "Oslo U.",
  "Linkoeping University": "Linköping U.",
  "Örebro University Hospital": "Örebro U.H.",
  "University of Helsinki": "Helsinki U.",
  "Gothenburg University": "Gothenburg U.",
  "Bispebjerg and Frederiksberg Hospital": "Bispebjerg and Frederiksberg H.",
  "Turku University Hospital": "Turku U.H.",
  "Nordsjællands Hospital": "Nordsjællands H.",
  "Lund University": "Lund U.",
  "University of Oulu": "Oulu U.",
  "University of Copenhagen": "Copenhagen U.",
  "St. Olav's University Hospital": "St. Olav's U.H.",
  "Holbæk Hospital": "Holbæk H.",
  "Aalborg University": "Aalborg U.",
  "Næstved Hospital": "Næstved H.",
  "Huddinge Hospital": "Huddinge H.",
  "University of Turku": "Turku U.",
  "University Hospital of North Norway": "North Norway U.H.",
  "UiT The Arctic University of Norway": "UiT",
  "University of Southern Denmark": "Southern Denmark U.",
  "Örebro University": "Örebro U.",
  "Umeå University": "Umeå U.",
  "Akershus University Hospital": "Akershus U.H.",
  "University of Bergen": "Bergen U.",
  "Danderyd Hospital": "Danderyd H.",
  "Mental health services in the Capital Region of Denmark":
    "Region Hovedstadens Psykiatri",
  "University of Eastern Finland": "Eastern Finland U.",
  "University of Iceland": "Iceland U.",
  "Stockholm South General Hospital": "Stockholm South General H.",
};

// Create reverse mapping for tooltip display
export const reverseMapSponsors = Object.fromEntries(
  Object.entries(mapSponsors).map(([fullName, shortName]) => [
    shortName,
    fullName,
  ])
);
